module.exports = __webpack_public_path__ + "img/nefp.f9a9f19b.svg";